import { IconComponentsProps } from './types';

const SortAscendingIcon = ({ fill = '#1010EB', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.707 10.293L9 11L12 14L15 11L14.293 10.293L12.5 12.086V2H11.5V12.086L9.707 10.293ZM1 9H8V10H1V9ZM8 6H3V7H8V6ZM5 3H8V4H5V3Z"
    />
  </svg>
);

export default SortAscendingIcon;
